import * as ListenerAPI from "../api/listener";
import * as DummyListenerAPI from "../dummyApi/listener";
import { isDemoMode } from "../stores/mode";
import type {
  LinkedInStartInput,
  LinkedInStartResponse,
  CallOfDutyStartInput,
  CallOfDutyStartResponse
} from "../api/listener";

interface ListenerApi {
  linkedInStart: (data: LinkedInStartInput) => Promise<LinkedInStartResponse>;
  callOfDutyStart: (data: CallOfDutyStartInput) => Promise<CallOfDutyStartResponse>;
}

const getAPI = (): ListenerApi => {
  return isDemoMode() ? DummyListenerAPI : ListenerAPI;
};

export const linkedInStart = async (data: LinkedInStartInput): Promise<LinkedInStartResponse> => {
  return getAPI().linkedInStart(data);
};

export const callOfDutyStart = async (data: CallOfDutyStartInput): Promise<CallOfDutyStartResponse> => {
  return getAPI().callOfDutyStart(data);
};
